import { Button, Tooltip } from '@chakra-ui/react'
import { useCallback, useState } from 'react'

import { useHotelsI18n } from '../../i18n'
import { ConfirmationDialog } from '../core/ConfirmationDialog'

interface ResetAllRoomsButtonProps {
  onReset: () => void
  isResetting?: boolean
  isDisabled?: boolean
}

export const ResetAllRoomsButton = ({
  onReset,
  isResetting = false,
  isDisabled = false,
}: ResetAllRoomsButtonProps) => {
  const { text } = useHotelsI18n()
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const handleConfirm = useCallback(() => {
    setIsConfirmOpen(false)
    onReset()
  }, [onReset])

  return (
    <>
      <Tooltip.Root openDelay={250}>
        <Tooltip.Trigger asChild>
          <Button
            colorPalette="error"
            variant="solid"
            size="sm"
            borderRadius="l2"
            fontWeight="medium"
            onClick={() => setIsConfirmOpen(true)}
            disabled={isDisabled}
            loading={isResetting}
          >
            {text('hotels.dashboard.resetAllRooms.buttonShort', 'Reset')}
          </Button>
        </Tooltip.Trigger>
        <Tooltip.Positioner>
          <Tooltip.Content>
            {text(
              'hotels.dashboard.resetAllRooms.tooltip',
              'Resets all rooms to Dirty',
            )}
          </Tooltip.Content>
        </Tooltip.Positioner>
      </Tooltip.Root>

      <ConfirmationDialog
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirm}
        title={text('hotels.dashboard.resetAllRooms.title', 'Reset All Rooms')}
        description={text(
          'hotels.dashboard.resetAllRooms.description',
          'This will set every room to Dirty status. Wake-up calls and voicemails will not be affected. Are you sure?',
        )}
        confirmLabel={text(
          'hotels.dashboard.resetAllRooms.confirm',
          'Reset All',
        )}
        confirmColorPalette="red"
      />
    </>
  )
}
